import React from 'react'
import { connect } from 'react-redux'
import styles from './CategoryTab.module.css'

class CategoryTab extends React.Component {

    notification() {
        if (this.props.unreadCount > 0 && this.props.unreadCount < 99)
            return (<div className={styles.counter}>{this.props.unreadCount}</div>);
        else if (this.props.unreadCount >= 99)
            return (<div className={styles.counter}>99+</div>);
        else
            return (<div />);
    }

    render() {

        return (
            <div className={styles.wrapper}>
                <div className={styles.notification}>
                    {this.notification()}
                </div>
                <div
                    className={(this.props.selected === true ? styles.category_tab_selected : styles.category_tab)}
                    onClick={() => this.props.changeCategory(this.props.categoryId)}>
                    {this.props.name}
                </div>
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    const unread = state.entities[(ownProps.entityKey)] ?
        Object.keys(state.entities[(ownProps.entityKey)])
            .filter(key => { return state.entities[(ownProps.entityKey)][key].isRead === false }).length : 0;

    return {
        unreadCount: unread
    };
}

const connectedCategoryTab = connect(mapStateToProps)(CategoryTab);
export { connectedCategoryTab as CategoryTab };
